import {ROLES} from '../constants';

const normalizeSlug = value => String(value || '').trim().toLowerCase();

const decodeSlug = value => {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};

const partnerProfile = profile => Boolean(
  profile &&
  profile.user &&
  profile.user.role === ROLES.partner
);

export const isPartnerOwnClubPath = (profile, pathname) => {
  if (!partnerProfile(profile) || !pathname || !profile.publicSlug) return false;

  const match = String(pathname).split(/[?#]/)[0].match(/^\/club\/([^/]+)\/?$/);
  if (!match) return false;

  return normalizeSlug(decodeSlug(match[1])) === normalizeSlug(profile.publicSlug);
};

export const isPartnerManagingCatalog = (profile, catalogPartner) => {
  if (!partnerProfile(profile) || !catalogPartner) return false;

  const profileId = profile.uid || profile.id;
  const catalogPartnerId = catalogPartner.uid || catalogPartner.id;
  if (profileId != null && catalogPartnerId != null) {
    return Number(profileId) === Number(catalogPartnerId);
  }

  return normalizeSlug(profile.publicSlug) === normalizeSlug(
    catalogPartner.slug || catalogPartner.publicSlug
  );
};
